export default __webpack_public_path__ + "static/media/pup-slide-1.ba864884.svg";